export const baseURLByEnv = {
  dev: 'https://develop-ai-api.joinpopp.com',
  staging: 'https://stage-ai-api.joinpopp.com',
  prod: 'https://ai-api.joinpopp.com'
};
